import type { components } from '../../../schema'

export type PaginationInfo = components['schemas']['PaginationInfo']

export function getNextPageParam(pagination: PaginationInfo): number | undefined {
  const nextOffset = pagination.offset + pagination.limit
  return nextOffset < pagination.total ? nextOffset : undefined
}